// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bebmt","option":"styles_option__m67cZ","selected":"styles_selected__5Dwtr"};